export * from './common-base-data';
export * from './common-selected-data';
export * from './message-kanri-model';
export * from './hizuke-Joho-model';



// WEBPACK FOOTER //
// ./src/app/modules/shared/data/index.ts